import { processDelayedStoredLogs } from '@shared/extension/utils/stored-logs';
import { processDelayedStoredRequests } from '@shared/extension/utils/stored-requests';
import 'reflect-metadata';
import { captureSentryMessage } from '@shared/sentry';
import * as Handlers from './handlers';
import { AuthService, Services } from './services';
import {
  initializeServiceWorker,
  processProfileEmail,
  reExecuteContentScripts,
  refreshCopilotNotificationConfigurations,
  refreshCopilotScripts,
  sendServiceWorkerInitializedAnalyticsEvent,
} from './utils';

captureSentryMessage('Service worker loaded');
// This should be at very start to ensure Alarm is registered before any other code
Handlers.startHandlingKeepAlive();

Handlers.startHandlingExceptions();

await AuthService.markUserAsSignedOut();

const services = new Services();

await initializeServiceWorker(services);
reExecuteContentScripts();
processDelayedStoredLogs();
processDelayedStoredRequests(services.commonStore.backendUrl$.value, 'service-worker');
// Disable copilot scripts and notification configurations in beyond.ai extension
// refreshCopilotNotificationConfigurations(services);
// refreshCopilotScripts(services);
processProfileEmail(services);
services.heartbeatService.start();
services.studentWatchService.startWatching();
services.learningService.startCheckingLearnedRecommendations();
services.localStorageService.startHandlingLocalStorageChanges();

Handlers.startHandlingActions(services);
Handlers.startHandlingAlarm(services);
Handlers.startHandlingContextMenuClicked(services);
Handlers.startHandlingInstallation();
Handlers.startHandlingStateChange();
Handlers.startHandlingStoredRequests(services);
Handlers.startHandlingStoredLogs(services);
Handlers.startHandlingUpdateAvailable();
Handlers.startHandlingWebRequestCompleted(services);

services.serviceWorkerSubscriptionsService.subscribe();

await sendServiceWorkerInitializedAnalyticsEvent(services);

captureSentryMessage('Service worker script execution completed');
